<template>
  <div class="resume-management">
    <!-- 隐藏的上传控件：用于点击按钮直接调起本地文件选择 -->
    <el-upload
      ref="hiddenUpload"
      style="display:none;"
      action="/api/upload/resume"
      :auto-upload="false"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-change="handleFileChange"
      accept=".pdf,application/pdf"
    />
    <!-- 我的简历 -->
    <div class="section">
      <div class="section-header">
        <h3 class="section-title">我的简历</h3>
        <button class="upload-btn" @click="handleUploadResume" :disabled="uploading">
          <i v-if="uploading" class="el-icon-loading"></i>
          <span v-else class="plus-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
              fill="none">
              <path
                d="M6 0C6.47339 2.06924e-08 6.85742 0.384035 6.85742 0.857422V5.14258H11.1426C11.616 5.14258 12 5.52661 12 6C12 6.47339 11.616 6.85742 11.1426 6.85742H6.85742V11.1426C6.85742 11.616 6.47339 12 6 12C5.52661 12 5.14258 11.616 5.14258 11.1426V6.85742H0.857422C0.384035 6.85742 3.2213e-08 6.47339 0 6C0 5.52661 0.384035 5.14258 0.857422 5.14258H5.14258V0.857422C5.14258 0.384035 5.52661 1.15206e-08 6 0Z"
                fill="url(#paint0_linear_4856_13105)" />
              <defs>
                <linearGradient id="paint0_linear_4856_13105" x1="0" y1="6" x2="12" y2="6"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
              </defs>
            </svg></span> {{ uploading ? '上传中...' : '上传简历' }}
        </button>
      </div>

      <div class="resume-list">
        <div v-for="(resume, index) in resumeList" :key="index" class="resume-item">
          <div class="resume-name">{{ resume.name }}</div>
          <div class="resume-meta">
            <span class="upload-time">上传时间：<span class="time-value">{{ resume.uploadTime }}</span></span>
            <span class="file-size">上传大小：<span class="time-value">{{ resume.size }}</span></span>
          </div>
          <div class="resume-actions">
            <button class="download-btn" @click="handleDownloadResume(resume)">
              <span class="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14.4001 13.7896H2.22413C1.84013 13.7896 1.53613 14.0936 1.53613 14.4776C1.53613 14.8616 1.84013 15.1656 2.22413 15.1656H14.4001C14.7841 15.1656 15.0881 14.8616 15.0881 14.4776C15.0881 14.1096 14.7841 13.7896 14.4001 13.7896ZM7.85613 12.6056C7.98413 12.7336 8.16013 12.7976 8.32013 12.7816C8.48013 12.7816 8.65613 12.7336 8.78413 12.6056L12.9441 8.44562C13.1841 8.20563 13.1841 7.80562 12.9441 7.56562C12.7041 7.32562 12.3041 7.32562 12.0641 7.56562L8.91213 10.7176V1.38962C8.91213 1.05362 8.64013 0.765625 8.28813 0.765625C7.93613 0.765625 7.66413 1.03762 7.66413 1.38962V10.6536L4.57613 7.56562C4.33613 7.32562 3.93613 7.32562 3.69613 7.56562C3.45613 7.80562 3.45613 8.20563 3.69613 8.44562L7.85613 12.6056Z"
                    fill="url(#paint0_linear_4856_13134)" />
                  <defs>
                    <linearGradient id="paint0_linear_4856_13134" x1="1.53613" y1="7.96563" x2="15.0881" y2="7.96563"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#62AFFF" />
                      <stop offset="1" stop-color="#9C41FF" />
                    </linearGradient>
                  </defs>
                </svg></span> 下载
            </button>
            <button class="delete-btn" @click="handleDeleteResume(resume, index)">
              <span class="delete-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                  viewBox="0 0 15 15" fill="none">
                  <g clip-path="url(#clip0_4856_13138)">
                    <path
                      d="M11.707 12.8086C11.707 13.3125 11.2969 13.7227 10.7934 13.7227H4.20703C3.96472 13.7223 3.73244 13.6259 3.5611 13.4545C3.38976 13.2832 3.29334 13.0509 3.29297 12.8086V3.10547H11.707V12.8086ZM5.12109 1.46484C5.12109 1.35938 5.20312 1.27734 5.30859 1.27734H9.70312C9.80859 1.27734 9.89016 1.35938 9.89016 1.46484V2.01562H5.12109V1.46484ZM14.4492 2.01562H10.9805V1.46484C10.9805 0.761719 10.4062 0.1875 9.70312 0.1875H5.30859C4.97005 0.188243 4.64558 0.323058 4.4062 0.562446C4.16681 0.801834 4.03199 1.1263 4.03125 1.46484V2.01562H0.550781C0.246094 2.01562 0 2.26172 0 2.56641C0 2.87109 0.246094 3.11719 0.550781 3.11719H2.19141V12.8086C2.19141 13.3432 2.40377 13.8559 2.78177 14.2339C3.15977 14.6119 3.67245 14.8242 4.20703 14.8242H10.793C11.3275 14.8242 11.8402 14.6119 12.2182 14.2339C12.5962 13.8559 12.8086 13.3432 12.8086 12.8086V3.10547H14.4492C14.7539 3.10547 15 2.85937 15 2.55469C15 2.25 14.7539 2.01562 14.4492 2.01562ZM7.5 12.0703C7.80469 12.0703 8.05078 11.8242 8.05078 11.5195V5.66016C8.05078 5.35547 7.80516 5.10938 7.5 5.10938C7.19531 5.10938 6.94922 5.35547 6.94922 5.66016V11.5195C6.94922 11.8242 7.19531 12.0703 7.5 12.0703ZM4.93359 12.0703C5.23828 12.0703 5.48438 11.8242 5.48438 11.5195V5.66016C5.48438 5.35547 5.23828 5.10938 4.93359 5.10938C4.62891 5.10938 4.38281 5.35547 4.38281 5.66016V11.5195C4.39453 11.8242 4.64062 12.0703 4.93359 12.0703ZM10.0664 12.0703C10.3711 12.0703 10.6177 11.8242 10.6177 11.5195V5.66016C10.6177 5.35547 10.3716 5.10938 10.0664 5.10938C9.76219 5.10938 9.51562 5.35547 9.51562 5.66016V11.5195C9.51562 11.8242 9.76172 12.0703 10.0664 12.0703Z"
                      fill="#F15D5D" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4856_13138">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg></span> 删除
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 我的作品集 -->
<!--     <div class="section">
      <div class="section-header">
        <h3 class="section-title">我的作品集</h3>
        <button class="upload-btn" @click="handleUploadPortfolio">
          <span class="plus-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
              fill="none">
              <path
                d="M6 0C6.47339 2.06924e-08 6.85742 0.384035 6.85742 0.857422V5.14258H11.1426C11.616 5.14258 12 5.52661 12 6C12 6.47339 11.616 6.85742 11.1426 6.85742H6.85742V11.1426C6.85742 11.616 6.47339 12 6 12C5.52661 12 5.14258 11.616 5.14258 11.1426V6.85742H0.857422C0.384035 6.85742 3.2213e-08 6.47339 0 6C0 5.52661 0.384035 5.14258 0.857422 5.14258H5.14258V0.857422C5.14258 0.384035 5.52661 1.15206e-08 6 0Z"
                fill="url(#paint0_linear_4856_13105)" />
              <defs>
                <linearGradient id="paint0_linear_4856_13105" x1="0" y1="6" x2="12" y2="6"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
              </defs>
            </svg></span> 上传作品集
        </button>
      </div>

      <div class="portfolio-list">
        <div v-for="(portfolio, index) in portfolioList" :key="index" class="portfolio-item">
          <div class="portfolio-name">{{ portfolio.name }}</div>
          <div class="portfolio-meta">
            <span class="upload-time">{{ portfolio.uploadTime }}</span>
            <span class="file-size">{{ portfolio.size }}</span>
          </div>
          <div class="portfolio-actions">
            <button class="download-btn" @click="handleDownloadPortfolio(portfolio)">
              <span class="download-icon">↓</span> 下载
            </button>
            <button class="delete-btn" @click="handleDeletePortfolio(portfolio, index)">
              <span class="delete-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                  viewBox="0 0 15 15" fill="none">
                  <g clip-path="url(#clip0_4856_13138)">
                    <path
                      d="M11.707 12.8086C11.707 13.3125 11.2969 13.7227 10.7934 13.7227H4.20703C3.96472 13.7223 3.73244 13.6259 3.5611 13.4545C3.38976 13.2832 3.29334 13.0509 3.29297 12.8086V3.10547H11.707V12.8086ZM5.12109 1.46484C5.12109 1.35938 5.20312 1.27734 5.30859 1.27734H9.70312C9.80859 1.27734 9.89016 1.35938 9.89016 1.46484V2.01562H5.12109V1.46484ZM14.4492 2.01562H10.9805V1.46484C10.9805 0.761719 10.4062 0.1875 9.70312 0.1875H5.30859C4.97005 0.188243 4.64558 0.323058 4.4062 0.562446C4.16681 0.801834 4.03199 1.1263 4.03125 1.46484V2.01562H0.550781C0.246094 2.01562 0 2.26172 0 2.56641C0 2.87109 0.246094 3.11719 0.550781 3.11719H2.19141V12.8086C2.19141 13.3432 2.40377 13.8559 2.78177 14.2339C3.15977 14.6119 3.67245 14.8242 4.20703 14.8242H10.793C11.3275 14.8242 11.8402 14.6119 12.2182 14.2339C12.5962 13.8559 12.8086 13.3432 12.8086 12.8086V3.10547H14.4492C14.7539 3.10547 15 2.85937 15 2.55469C15 2.25 14.7539 2.01562 14.4492 2.01562ZM7.5 12.0703C7.80469 12.0703 8.05078 11.8242 8.05078 11.5195V5.66016C8.05078 5.35547 7.80516 5.10938 7.5 5.10938C7.19531 5.10938 6.94922 5.35547 6.94922 5.66016V11.5195C6.94922 11.8242 7.19531 12.0703 7.5 12.0703ZM4.93359 12.0703C5.23828 12.0703 5.48438 11.8242 5.48438 11.5195V5.66016C5.48438 5.35547 5.23828 5.10938 4.93359 5.10938C4.62891 5.10938 4.38281 5.35547 4.38281 5.66016V11.5195C4.39453 11.8242 4.64062 12.0703 4.93359 12.0703ZM10.0664 12.0703C10.3711 12.0703 10.6177 11.8242 10.6177 11.5195V5.66016C10.6177 5.35547 10.3716 5.10938 10.0664 5.10938C9.76219 5.10938 9.51562 5.35547 9.51562 5.66016V11.5195C9.51562 11.8242 9.76172 12.0703 10.0664 12.0703Z"
                      fill="#F15D5D" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4856_13138">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg></span> 删除
            </button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 上传对话框 -->
    <el-dialog :title="uploadDialog.title" :visible.sync="uploadDialog.visible" width="500px"
      @close="handleUploadClose">
      <el-upload ref="upload" :action="uploadDialog.action" :before-upload="beforeUpload"
        :file-list="uploadDialog.fileList"
        :auto-upload="false" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持 PDF 格式，单个文件不超过 10MB</div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialog.visible = false" :disabled="uploading">取消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="uploading">确定上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadResume } from '@/api/upload'
import { saveResume, getResumeList, deleteResumes } from '@/api/resume'
export default {
  name: 'ResumeManagement',
  data() {
    return {
      resumeList: [],
      uploading: false, // 上传中状态
      portfolioList: [
        {
          name: '我的作品集(产品经理...',
          uploadTime: '2025/02/26 16:40',
          size: '5mb',
          url: '#'
        },
        {
          name: '我的作品集(UI设计师...',
          uploadTime: '2025/02/26 16:40',
          size: '5mb',
          url: '#'
        },
        {
          name: '我的作品集(前端工程...',
          uploadTime: '2025/02/26 16:40',
          size: '5mb',
          url: '#'
        }
      ],
      uploadDialog: {
        visible: false,
        title: '',
        action: '/api/upload',
        fileList: [],
        type: '' // 'resume' or 'portfolio'
      }
    }
  },
  created() {
    this.fetchResumeList()
  },
  methods: {
    async fetchResumeList() {
      try {
        const res = await getResumeList({})
        const list = (res && res.data && (res.data.data || res.data.list)) || []
        this.resumeList = list.map(item => {
          const name = item.resume_name || item.name || ''
          const url = item.resume_url || item.url || ''
          const rawSize = item.resume_size !== undefined ? item.resume_size : item.size
          const sizeStr = typeof rawSize === 'number' ? `${rawSize} MB` : (rawSize || '')
          const rawTime = item.upload_time || item.create_time
          const uploadTime = rawTime ? this.tryFormatTime(rawTime) : ''
          const id = item.id
          return { id, name, url, size: sizeStr, uploadTime }
        })
      } catch (e) {
        this.$message.error('获取简历列表失败')
      }
    },
    handleUploadResume() {
      // 如果正在上传，不允许再次上传
      if (this.uploading) return
      // 直接调起本地文件选择
      this.uploadDialog.type = 'resume'
      this.$nextTick(() => {
        const inputEl = this.$refs.hiddenUpload && this.$refs.hiddenUpload.$el && this.$refs.hiddenUpload.$el.querySelector('input[type="file"]')
        if (inputEl) inputEl.click()
      })
    },

    handleUploadPortfolio() {
      this.uploadDialog = {
        visible: true,
        title: '上传作品集',
        action: '/api/upload/portfolio',
        fileList: [],
        type: 'portfolio'
      }
    },

    beforeUpload(file) {
      const isPdf = file.type === 'application/pdf'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isPdf) {
        this.$message.error('只能上传 PDF 格式的文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },

    async submitUpload() {
      const files = this.$refs.upload && this.$refs.upload.uploadFiles
      if (!files || files.length === 0) {
        this.$message.error('请先选择要上传的PDF文件')
        return
      }
      const rawFile = files[0].raw || files[0]
      await this.uploadRawFile(rawFile)
    },

    async handleFileChange(file) {
      const raw = file && (file.raw || file)
      if (!raw) return
      await this.uploadRawFile(raw)
    },

    async uploadRawFile(rawFile) {
      if (!this.beforeUpload(rawFile)) return
      this.uploading = true
      try {
        // 使用 uploadResume 接口上传文件
        const response = await uploadResume({
          file: rawFile,
          url: '/api/upload/resume',
          encodeFileName: false
        })
        
        // 获取上传后的 URL
        const uploadedUrl = response?.data?.data?.resumeUrl || response?.data?.data?.url
        if (!uploadedUrl) {
          throw new Error('上传响应无有效URL')
        }

        const sizeInMB = Number((rawFile.size / 1024 / 1024).toFixed(2))
        const payload = {
          resume_name: rawFile.name,
          resume_size: sizeInMB,
          resume_url: uploadedUrl
        }
        await saveResume(payload)

        this.$message.success('上传成功!')
        this.uploadDialog.visible = false
        // 重新拉取列表
        await this.fetchResumeList()
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '上传失败，请重试!')
      } finally {
        this.uploading = false
      }
    },

    tryFormatTime(val) {
      // 支持时间戳或日期字符串
      try {
        let date
        if (typeof val === 'number') {
          // 判断是秒级还是毫秒级时间戳
          // 如果时间戳小于等于10位数，认为是秒级时间戳，需要乘以1000
          const timestamp = val.toString().length <= 10 ? val * 1000 : val
          date = new Date(timestamp)
        } else {
          date = new Date(String(val).replace(/-/g, '/'))
        }
        if (isNaN(date.getTime())) return String(val)
        return this.formatDate(date)
      } catch (e) {
        return String(val)
      }
    },

    handleDeleteResume(resume, index) {
      console.log('resume', resume);
      
      this.$confirm('确定要删除这个简历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          if (!resume.id) {
            this.resumeList.splice(index, 1)
            this.$message.success('删除成功!')
            return
          }
          await deleteResumes(resume.id)
          this.$message.success('删除成功!')
          await this.fetchResumeList()
        } catch (e) {
          this.$message.error('删除失败，请重试!')
        }
      })
    },

    handleUploadClose() {
      this.uploadDialog.visible = false
      this.uploadDialog.fileList = []
    },

    handleDownloadResume(resume) {
      console.log('resume', resume);
      if (!resume || !resume.url) {
        this.$message.error('下载地址不存在')
        return
      }
      this.downloadFile(resume.url, resume.name || 'resume.pdf')
    },

    handleDownloadPortfolio(portfolio) {
      // 模拟下载
      this.$message.success(`正在下载: ${portfolio.resume_name}`)
    },

    handleDeletePortfolio(portfolio, index) {
      this.$confirm('确定要删除这个作品集吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.portfolioList.splice(index, 1)
        this.$message.success('删除成功!')
      })
    },

    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}/${month}/${day} ${hours}:${minutes}`
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    downloadFile(url, filename) {
      try {
        // 若是绝对链接，直接新开标签页；否则尝试下载
        const isHttp = /^https?:\/\//i.test(url)
        if (isHttp) {
          const a = document.createElement('a')
          a.href = url
          a.download = filename || ''
          a.target = '_blank'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          return
        }
        const a = document.createElement('a')
        a.href = url
        a.download = filename || ''
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (e) {
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.resume-management {
  padding: 0;
  background: transparent;
  min-height: 100%;
}


/* 章节样式 */
.section {
  margin-bottom: 40px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #656587;
  margin: 0 0 20px 0;
}

/* 上传按钮 */
.upload-btn {
  background: #fff;
  border: 1px solid #B16EF9;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s;
  height: 28px;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .el-icon-loading {
    animation: rotating 2s linear infinite;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



.plus-icon {
  font-size: 16px;
  font-weight: bold;
}

/* 列表样式 */
.resume-list,
.portfolio-list {
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: visible;
}

.resume-item,
.portfolio-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  padding: 16px 20px;
  border-radius: 8px;
  background: linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.20) 99.08%);
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);
  transition: background-color 0.3s;
  gap: 20px;
}

.resume-item:last-child,
.portfolio-item:last-child {
  border-bottom: none;
}


.resume-name,
.portfolio-name {
  font-size: 14px;
  color: #1d2129;
  font-weight: 500;
  line-height: 1.4;
  justify-self: start;
}

.resume-meta,
.portfolio-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #86909c;
  justify-content: space-between;
  align-items: center;
  justify-self: stretch;
}

.upload-time,
.file-size {
  display: inline-block;
}

.upload-time {
  font-weight: normal;
}

.time-value {
  font-weight: 600;
}

/* 操作按钮 */
.resume-actions,
.portfolio-actions {
  display: flex;
  gap: 8px;
  justify-self: end;
}

.download-btn {
  background: #e3f2fd;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s;
}



.delete-btn {
  color: #F15D5D;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s;
}



.download-icon,
.delete-icon {
  font-size: 12px;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

/* 上传组件样式调整 */
.el-upload-dragger {
  width: 100%;
  height: 180px;
}

.el-upload__tip {
  color: #86909c;
  font-size: 12px;
  margin-top: 8px;
}
</style>
